const ellipsis = '...';
const forbiddenLastCharacters = [' ', '-', '.', ',', '!'];
const deleteForbiddenCharsFromEnd = (str, characters) => {
    const lastChar = str.charAt(str.length - 1);
    if (!str || !characters.includes(lastChar)) {
        return str;
    }
    return deleteForbiddenCharsFromEnd(str.slice(0, -1), characters);
};
export const ellipsize = (str, maxLength) => {
    if (!str || str.length <= maxLength) {
        return str;
    }
    if (maxLength <= ellipsis.length) {
        return str.slice(0, maxLength);
    }
    const maxStrLength = Math.max(maxLength - ellipsis.length, 0);
    const truncatedStr = str.slice(0, maxStrLength);
    return `${deleteForbiddenCharsFromEnd(truncatedStr, forbiddenLastCharacters)}${ellipsis}`;
};
